import React, { Component } from 'react';
import { firebaseAuth, pythonApiIp, db, logComponentLoad, firebaseStorage, logDashboardAction } from '../../../../config/constants'
import FileUploader from 'react-firebase-file-uploader';
import { Progress, Divider, Button, Form } from 'semantic-ui-react';
import { getPrintValues, checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import Select from 'react-select';
import { SingleDatePicker } from 'react-dates';
import axios from 'axios'
import * as UiConsts from '../../../../config/UiConstants';

import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });


export default class AddDocument extends Component {
    constructor(props) {
        super(props);
        this.state = {
            progress: 0,
            isUploading: false,
            fileName: '',
            fileUrl: '',
            actualFileName: '',
            docUrl: '',
            documentType: '',
            typeChoices: [],
            dateNum: '',
            algoliaUser: ''
        }
    }

    componentDidMount() {

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("addx24 +++++++++:firebaseAuth().onAuthStateChanged");

            if (user) {
                console.log("addx241 user is:" + user.email);
                // let isAnonymous = user.isAnonymous;
                // let uid = user.uid;

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                    // this.getApiDetails();
                    //getShirtTypes(this.loadShirtTypes);

                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })

            }
        })
    }

    setAdminResult = (returnObject) => {
        //console.log("++++++ addx294 setAdminResult");
        // console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })

        logComponentLoad(returnObject, "AddDocument");

        if (returnObject.algoliaUser.perms && returnObject.algoliaUser.perms.includes("addDocument")) {


            getPrintValues("documentType", this.loadtypes);

        }
    }

    loadtypes = (docTypes) => {
        console.log("docx1 ++++++ loadStatuses ");
        console.log("docx12 docs:" + JSON.stringify(docTypes, null, 3));
        this.setState({ typeChoices: docTypes })
    }

    /**
     * HANDLE THE FILE UPLOADING..
     */
    handleUploadStart = (file) => {
        console.log("docx14 ++++++ handle uploadStart file:" + file.name.split('.')[0]);

        this.setState({ isUploading: true, progress: 0, actualFileName: file.name });
    }


    // handleUploadSuccess = (fileName) => this.setState({fileName:fileName, isUploading: false, progress: 100});
    handleUploadSuccess = (saveFileName) => {
        console.log("docx15 +++++++handleUploadSuccess");

        this.setState({ fileName: saveFileName, isUploading: false, progress: 100 });

        //UDPATE URL 
        // let orderKey = this.props.fileName;
        firebaseStorage.ref('printbdocs').child(saveFileName).getDownloadURL().then(
            url => {
                this.setState({ docUrl: url })
                console.log("docx16 docUrl is:" + url);

                // let tempRef = db.ref('orders').child(orderKey);
                // //UDPATE FIREBASE OBJECT WITH OBJECT NAME..
                // tempRef.update('fileUrl':url);

                // let updates = {};
                // updates['/orders/' + orderKey + '/fileUrl'] = url;
                // updates['/orders/' + orderKey + '/fileName'] = saveFileName;
                // updates['/orders/' + orderKey + '/usersFileName'] = this.state.actualFileName;
                // ref.update(updates);
                this.updateWhenFileUploadComplete(true, this.state.actualFileName, url);
            }
        );
    };

    //  firebase.storage().ref('images').child(filename).getDownloadURL().then(url => this.setState({avatarURL: url}));
    handleProgress = (progress) => this.setState({ progress });
    handleUploadError = (error) => {
        console.log("docx16 +++++++: handleUploadError");

        this.setState({ isUploading: false });
        console.error(error);
    }

    updateWhenFileUploadComplete = (uploaded, fileName, url) => {
        console.log("docx17 +++++++: updateWhenFileUploadComplete");
        console.log("docx181 uploaded:" + uploaded);
        console.log("docx18 fileName:" + fileName);
        console.log("docx19 url:" + url)
    }


    handleDropDownChanges = (value) => {
        console.log("docx19 handleDropDownChanges");
        console.log('docx191 You\'ve sss:', value);
        console.log("docx192 category alone:" + value.category);
        console.log('docx193 You\'ve selected:', value.value + " " + value.category);
        console.log("docx195 - array index:" + this.props.arrayIndex);

        let newState = {};
        newState[value.category] = value.value;
        console.log("newState 1:" + JSON.stringify(newState, null, 3));

        //this.setState(newState);
        this.setState(newState);
    }


    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    dateSelectOnChange = (date) => {
        console.log("++++++++:dateSelectOnChange");
        console.log("date:" + date);
        console.log("date.getValue():" + date.valueOf());
        this.setState({
            date: date,
            dateNum: date.valueOf(),
            dateString: date.format('dddd MMMM Do')

        })
    }

    uploadDocument = () => {
        console.log("++++++++:sendCustomer");
        console.log("docx3 Project Id: " + this.props.projectId)
        console.log("docx32 Project docUrl: " + this.props.docUrl)
        //console.log("docx32 this.props.user.email " + this.props.user.email)
        console.log("docx32 this.type " + this.state.type)

        console.log("dateNum:" + this.state.dateNum)

        if (this.state.docUrl == '') {
            alert("No docUrl Selected")
        } else if (this.state.type == '') {
            alert("No type Entered")
        } else {
            console.log("sending data..");

            this.setState({ loading: true });

            axios.post(pythonApiIp + 'addGenericDocument', {
                apiKey: "asdsadfasd",
                docUrl: this.state.docUrl,
                enteredBy: "ivanmworozi@gmail.com",
                type: this.state.documentType,
                description: this.state.description

            })
                .then((response) => {

                    console.log(response.data);

                    if (response.data.result) {
                        console.log("true.. documented added");

                        logDashboardAction(this.state.user.email + " uploaded document " + this.state.documentType + " for " + this.state.description, this.state.user.email, null, "AddDocument");

                        //this.resetFeilds();
                        this.setState({ loading: false });
                        alert(response.data.message);

                        // history.push("/dashboard/viewLargeProject/" + this.props.projectId);
                    } else {
                        console.log("FAILED");
                        this.setState({ loading: false })
                        alert(response.data.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({ loading: false })
                });
        }
    }


    render() {

        const progressBarUI = (this.state.isUploading ? <Progress percent={this.state.progress} progress /> : "")

        const fileUploadUI = this.state.type !== ''
            ? <FileUploader
                accept="*,"
                name="avatar"
                filename={this.props.fileName}
                //storageRef={firebaseStorage.ref('orderDesigns/')}
                storageRef={firebaseStorage.ref('printbdocs')}
                onUploadStart={this.handleUploadStart}
                onUploadSuccess={this.handleUploadSuccess}
                onProgress={this.handleProgress}
            />
            : ''

        const uploadButton = this.state.docUrl
            ? <Button color='red' onClick={this.uploadDocument}>UPLOAD</Button>
            : ''

        const wholeUI = this.state.algoliaUser && this.state.algoliaUser != '' && this.state.algoliaUser.perms && this.state.algoliaUser.perms.includes("addDocument")
            ? <div>
                <Divider horizontal>{'UPLOAD DOCUMENT'}</Divider>

                <label> DOCUMENT TYPE </label>
                <Select
                    name="form-field-name"
                    value={this.state.documentType}
                    options={this.state.typeChoices}
                    onChange={this.handleDropDownChanges}
                    searchable={false}
                    clearable={false}
                />


                <label> DESCRIPTION</label>
                <Form.Input
                    fluid
                    icon='mail'
                    iconPosition='left'
                    placeholder='Description'
                    type='text'
                    name="description"
                    value={this.state.description}
                    onChange={this.handleTextInputChange}
                />

                {fileUploadUI}

                {/* <h4>URL:{this.state.fileUrl}</h4> */}
                {/* <Progress percent={this.state.progress} progress /> */}
                {progressBarUI}
                {uploadButton}
                <br />
                <br />
            </div>
            : <h4>loading error a75</h4>

        return (this.state.loading ? <UiConsts.LoadingComponent /> :
            <div>

                {wholeUI}


            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/AddDocuments/AddDocument.js